import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { MCAgent } from '@/types/mission-control';
import { QUERY_ROOT } from '../constants';
import { callAgentForge } from './http';
import type { AgentsListResponse } from './agents.types';

const AGENTS_STALE_TIME_MS = 5 * 60_000;

export const agentsKey = () => [QUERY_ROOT, 'agents'] as const;

const listAgents = async (
  signal: AbortSignal | undefined
): Promise<MCAgent[]> => {
  // Legacy uses `/mission-control/agents` and unwraps either an array directly
  // or `{ agents: [...] }` depending on backend version.
  const body = await callAgentForge<MCAgent[] | AgentsListResponse>({
    url: '/mission-control/agents',
    signal,
  });
  return Array.isArray(body) ? body : (body.agents ?? []);
};

export const useAgentsQuery = (): UseQueryResult<MCAgent[], Error> =>
  useQuery({
    queryKey: agentsKey(),
    queryFn: ({ signal }) => listAgents(signal),
    staleTime: AGENTS_STALE_TIME_MS,
  });
